<template>
  <div class="row q-col-gutter-y-md text-center">
    <div class="col-12 col-sm-6">
      <div class="text-h5">
        {{ postImport.numPosts }}
      </div>
      <div class="text-body1 text-uppercase">Posts</div>
    </div>
    <div class="col-12 col-sm-6">
      <div class="text-h5">{{ duration }}</div>
      <div class="text-body1 text-uppercase">Duration</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostImport } from '@/social/types';
import { JobRun } from '@/type';
import { humanizeTimeDiff } from '@/common/date';

export default defineComponent({
  props: {
    postImport: {
      type: Object as () => PostImport,
      required: true,
    },
    jobRun: {
      type: Object as () => JobRun,
      required: true,
    },
  },
  computed: {
    duration(): string {
      if (this.jobRun.finishedAt === null) return 'N/A';
      return humanizeTimeDiff(this.jobRun.startedAt, this.jobRun.finishedAt);
    },
  },
});
</script>
